import { baseApi } from './baseQuery'
import { SkuOptionsResponse, SkuPriceOptionsResponse } from '@/types/interfaces/sku'
import { apiEndpoints } from '@/lib/api/endpoints'

export const skuOptionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSkuOptions: builder.query<SkuOptionsResponse, string>({
      query: (skuId) => apiEndpoints.skus.getOptions(skuId),
      providesTags: (result, error, skuId) => [
        { type: 'Sku', id: skuId },
        { type: 'Sku', id: `options-${skuId}` }
      ],
      keepUnusedDataFor: 300,
    }),
    getSkuOptionsForLocationState: builder.query<SkuOptionsResponse, { skuId: string; appointmentLocationState?: string | null }>({
      query: ({ skuId, appointmentLocationState }) => apiEndpoints.skus.getOptionsForLocationState(skuId, appointmentLocationState),
      providesTags: (result, error, { skuId }) => [
        { type: 'Sku', id: skuId },
        { type: 'Sku', id: `options-${skuId}` }
      ],
      keepUnusedDataFor: 300,
    }),
    getSkuOptionsForNextStep: builder.query<SkuOptionsResponse, { skuId: string; nextStepId: string }>({
      query: ({ skuId, nextStepId }) => apiEndpoints.skus.getOptionsWithNextStep(skuId, nextStepId),
      providesTags: (result, error, { skuId, nextStepId }) => [
        { type: 'Sku', id: skuId },
        { type: 'Sku', id: `options-${skuId}` },
        { type: 'Prescription', id: nextStepId },
      ],
      keepUnusedDataFor: 300,
    }),
    getSkuOptionsForRenewalContext: builder.query<
      SkuOptionsResponse,
      { skuId: string; renewalQuestionnaireResponseId: string; nextStepId?: string }
    >({
      query: ({ skuId, renewalQuestionnaireResponseId, nextStepId }) =>
        apiEndpoints.skus.getOptionsWithRenewalContext(skuId, renewalQuestionnaireResponseId, nextStepId),
      providesTags: (_result, _error, { skuId, renewalQuestionnaireResponseId, nextStepId }) => [
        { type: 'Sku', id: skuId },
        { type: 'Sku', id: `options-${skuId}` },
        { type: 'Prescription', id: renewalQuestionnaireResponseId },
        ...(nextStepId ? [{ type: 'Prescription' as const, id: nextStepId }] : []),
      ],
      keepUnusedDataFor: 300,
    }),
    getSkuPrices: builder.query<SkuPriceOptionsResponse, string>({
      query: (skuId) => apiEndpoints.skus.getPrices([skuId]),
      providesTags: (result, error, skuId) => [{ type: 'Sku', id: `prices-${skuId}` }],
      keepUnusedDataFor: 300,
    }),
  }),
})

export const {
  useGetSkuOptionsQuery,
  useGetSkuOptionsForLocationStateQuery,
  useGetSkuOptionsForNextStepQuery,
  useGetSkuOptionsForRenewalContextQuery,
  useGetSkuPricesQuery,
} = skuOptionsApi

